import Vue from "vue";
import msal from "vue-msal";

Vue.config.productionTip = false;

Vue.use(msal, {
  auth: {
    clientId: "e24f5e57-df2f-437b-9593-4f311cd7ec88",
    authority:
      "https://login.microsoftonline.com/f29e6370-28fe-4e77-83f7-233e5ff5a8c9/",
    redirectUri: "https://fastfurniture.cekaso.de",
    postLogoutRedirectUri: "https://fastfurniture.cekaso.de",
    navigateToLoginRequestUrl: false
  }
});



// WEBPACK FOOTER //
// ./src/vue-msal.js